export const SUCCESS_TIMEOUT = 1000;
